import script from "./HowToReturnCY.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToReturnCY.vue?vue&type=script&setup=true&lang=js"

import "./HowToReturnCY.vue?vue&type=style&index=0&id=e49f59fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e49f59fa"]])

export default __exports__